var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteImageico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 480.046 480.046"
    },
    xmlSpace: "preserve",
    width: 480.046,
    height: 480.046,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.078,216.172l-20.25-11.914c-0.602-2.441-1.258-4.867-1.977-7.258l14.406-21.805c1.528-2.31,1.753-5.246,0.594-7.762    c-5.035-10.878-11.172-21.212-18.313-30.84c-1.608-2.129-4.155-3.337-6.82-3.234l-26.844,1.32    c-1.688-1.73-3.411-3.418-5.172-5.063l1.344-26.008c0.142-2.745-1.135-5.371-3.383-6.953c-9.889-6.982-20.449-12.96-31.523-17.848    c-2.433-1.076-5.242-0.87-7.492,0.551l-22.5,14.176c-2.438-0.699-4.922-1.348-7.43-1.937L264.461,68.3    c-1.383-2.629-4.108-4.276-7.078-4.277h-34.719c-2.97,0.001-5.696,1.648-7.078,4.277l-12.25,23.297    c-2.5,0.586-4.979,1.232-7.437,1.937l-22.492-14.176c-2.247-1.419-5.053-1.627-7.484-0.555    c-11.081,4.887-21.647,10.868-31.539,17.855c-2.242,1.583-3.516,4.204-3.375,6.945l1.344,26.012    c-1.766,1.645-3.49,3.329-5.172,5.055l-26.852-1.32c-2.662-0.072-5.199,1.131-6.828,3.238    c-7.127,9.634-13.257,19.967-18.297,30.84c-1.158,2.514-0.936,5.447,0.586,7.758L90.195,197c-0.719,2.391-1.375,4.816-1.977,7.258    l-20.25,11.91c-2.445,1.436-3.946,4.059-3.946,6.894v33.918c0,2.835,1.501,5.458,3.945,6.895l20.25,11.91    c0.602,2.441,1.258,4.867,1.977,7.262l-14.406,21.801c-1.528,2.31-1.753,5.246-0.594,7.762    c5.036,10.879,11.172,21.214,18.313,30.844c1.614,2.121,4.157,3.327,6.82,3.234l26.844-1.32c1.688,1.731,3.411,3.418,5.172,5.063    L131,376.434c-0.142,2.745,1.135,5.371,3.383,6.953c9.889,6.982,20.449,12.962,31.523,17.852c2.434,1.072,5.241,0.865,7.492-0.551    l22.5-14.176c2.437,0.699,4.922,1.348,7.43,1.937l12.258,23.297c1.382,2.629,4.108,4.276,7.078,4.278h34.719    c2.97-0.001,5.696-1.648,7.078-4.277l12.25-23.297c2.5-0.586,4.979-1.232,7.438-1.937l22.492,14.176    c2.248,1.415,5.052,1.623,7.484,0.555c11.081-4.887,21.647-10.868,31.539-17.855c2.242-1.583,3.516-4.204,3.375-6.945    l-1.344-26.012c1.766-1.645,3.49-3.331,5.172-5.059l26.852,1.32c2.668,0.115,5.221-1.096,6.82-3.234    c7.133-9.633,13.266-19.968,18.305-30.844c1.158-2.514,0.936-5.447-0.586-7.758l-14.406-21.809    c0.719-2.391,1.375-4.816,1.977-7.258l20.25-11.91c2.445-1.436,3.946-4.059,3.945-6.894v-33.918    C416.024,220.232,414.523,217.608,412.078,216.172z M400.023,252.407l-19.266,11.332c-1.917,1.126-3.279,3-3.758,5.172    c-0.961,4.367-2.148,8.703-3.516,12.887c-0.76,2.319-0.42,4.857,0.922,6.895h0l14,21.199c-3.563,7.165-7.657,14.053-12.25,20.605    l-26.164-1.285c-2.349-0.068-4.617,0.857-6.25,2.547c-3.023,3.246-6.227,6.383-9.539,9.324c-1.819,1.612-2.805,3.964-2.68,6.391    l1.305,25.32c-6.797,4.538-13.921,8.567-21.312,12.055l-21.914-13.813c-1.983-1.254-4.418-1.57-6.656-0.863    c-4.297,1.344-8.75,2.504-13.227,3.445c-2.335,0.487-4.329,1.993-5.437,4.105l-11.727,22.301h-25.063l-11.727-22.301    c-1.109-2.108-3.099-3.613-5.43-4.105c-4.516-0.953-8.969-2.109-13.234-3.445c-2.237-0.708-4.673-0.392-6.656,0.863    l-21.922,13.812c-7.391-3.492-14.514-7.524-21.313-12.063l1.313-25.312c0.124-2.432-0.865-4.788-2.688-6.402    c-3.297-2.922-6.508-6.059-9.539-9.316c-1.62-1.708-3.897-2.636-6.25-2.547l-26.156,1.285    c-4.598-6.549-8.695-13.436-12.258-20.602l14-21.195c1.348-2.036,1.691-4.578,0.93-6.898c-1.367-4.184-2.555-8.523-3.516-12.891    c-0.479-2.172-1.84-4.046-3.758-5.172l-19.266-11.332v-24.762l19.266-11.332c1.917-1.126,3.279-3,3.758-5.172    c0.961-4.367,2.148-8.703,3.516-12.887c0.76-2.319,0.42-4.857-0.922-6.895l-14-21.203c3.564-7.164,7.659-14.052,12.25-20.605    l26.164,1.289c2.358,0.118,4.646-0.815,6.25-2.547c3.023-3.246,6.227-6.383,9.539-9.324c1.819-1.612,2.805-3.964,2.68-6.391    l-1.305-25.32c6.797-4.538,13.921-8.567,21.312-12.055l21.914,13.813c1.985,1.25,4.418,1.565,6.656,0.863    c4.297-1.344,8.75-2.504,13.227-3.445c2.335-0.487,4.329-1.993,5.437-4.105l11.727-22.301h25.063l11.727,22.301    c1.109,2.108,3.099,3.613,5.43,4.105c4.516,0.953,8.969,2.109,13.234,3.445c2.238,0.697,4.67,0.382,6.656-0.863L311.523,95.2    c7.391,3.491,14.514,7.521,21.313,12.059l-1.313,25.316c-0.124,2.432,0.865,4.788,2.688,6.402    c3.297,2.922,6.508,6.059,9.539,9.316c1.616,1.715,3.896,2.644,6.25,2.547l26.156-1.285c4.598,6.549,8.695,13.436,12.258,20.602    l-14,21.195c-1.348,2.036-1.691,4.578-0.93,6.898c1.367,4.184,2.555,8.519,3.516,12.887c0.479,2.172,1.84,4.046,3.758,5.172    l19.266,11.332V252.407z",
    id: "svg_3",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_4",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.023,120.024c-66.274,0-120,53.726-120,120s53.726,120,120,120s120-53.726,120-120    C359.95,173.78,306.267,120.097,240.023,120.024z M240.023,344.024c-57.438,0-104-46.562-104-104s46.562-104,104-104    s104,46.562,104,104C343.958,297.434,297.434,343.959,240.023,344.024z",
    id: "svg_6",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7",
    className: "",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_8",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.023,32.024v48h-48v16h56c4.417,0.001,7.999-3.579,8-7.996c0-0.001,0-0.003,0-0.004v-56H408.023z",
    id: "svg_9",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10",
    className: "",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_11",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.023,384.024c-4.417-0.001-7.999,3.579-8,7.996c0,0.001,0,0.003,0,0.004v56h16v-48h48v-16H64.023z",
    id: "svg_12",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_14",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.402,105.327C14.444,145.075,0.03,191.996,0.023,240.024c-0.086,48.065,14.338,95.036,41.383,134.77l13.234-9    c-69.445-102.4-42.731-241.708,59.669-311.153c75.92-51.488,175.558-51.489,251.48-0.003l9-13.234    C265.074-33.007,115.812-4.387,41.402,105.327z",
    id: "svg_15",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_17",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.219,107.606l-13.344,8.836c68.236,103.211,39.884,242.196-63.326,310.432    c-75.72,50.061-174.164,49.483-249.291-1.463l-9,13.234c109.716,74.409,258.979,45.787,333.388-63.929    C493.238,294.221,493.859,188.738,440.219,107.606z",
    id: "svg_18",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "svg_22"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_25"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_26"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_27"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_28"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svg_30"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "svg_31"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "svg_32"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "svg_33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteImageico);
export default __webpack_public_path__ + "static/media/white_imageico.5548838cbe77833eed393e657743a7dc.svg";
export { ForwardRef as ReactComponent };